import twinpeakrealtorsLogo from 'assets/twinpeakrealtors/logo.png'
import twinpeakrealtorsLogoOnDark from 'assets/twinpeakrealtors/logo-on-dark.png'
import twinpeakrealtorsLogoIcon from 'assets/twinpeakrealtors/logo-icon.png'
import {
  generateColors,
  generateDarkTheme,
  generateTheme
} from '../generateTheme'
import type { TenantConfig, TenantSeedTheme } from '../types'

// Twin Peak Realtors — Pune-based real-estate developer. Palette is taken
// straight from the marketing site (twinpeakrealtors.com), whose Tailwind
// theme exposes these as --color-dark / --color-primary / --color-light:
//   • Primary  navy   #0E1A2B ≈ hsl(215 51% 11%) — headers, nav, primary
//     buttons and the whole derived neutral palette. Also the site's
//     <meta name="theme-color">.
//   • Accent   gold   #C8A35A ≈ hsl(40 50% 57%) — CTAs, highlights, gradient
//     warm stop. A muted antique gold, NOT a saturated amber; the site pairs
//     it with #B08D3E (dark) and #D4B87A (light).
//   • Soft     cream  #F7F1E6 — light accent surfaces (see --brand-accent-soft).
//     This is the site's --color-gold-glow (#c8a35a26) composited on white.
//   • Warm     taupe  #887456 — warm neutral (see --brand-warm / BRAND.warm).
const seed: TenantSeedTheme = {
  primary: '215 51% 11%',
  secondary: '40 50% 57%',
  emailPrimaryHex: '#0E1A2B',
  emailSecondaryHex: '#C8A35A'
}

const twinpeakrealtorsConfig: TenantConfig = {
  id: 'twinpeakrealtors',
  name: 'Twin Peak Realtors',
  tagline: 'Leading by example',
  // Black "REALTORS" subtitle — for light backgrounds (form side, header, public).
  logo: twinpeakrealtorsLogo,
  // White "REALTORS" subtitle — for the dark brand panel (authBrandBackground).
  logoTransparent: twinpeakrealtorsLogoOnDark,
  logoIcon: twinpeakrealtorsLogoIcon,
  // Brand navy, matching the site's dark sections — not a neutral off-black.
  authBrandBackground: '#0E1A2B',
  favicon: twinpeakrealtorsLogoIcon,
  websiteUrl: 'https://twinpeakrealtors.com',
  supportEmail: 'support@twinpeakrealtors.com',
  supportPhone: '+91 20 0000 0000',
  theme: generateTheme(seed),
  darkTheme: generateDarkTheme(seed),
  colors: generateColors('#0E1A2B', '#C8A35A'),
  // Royal blue — the interactive primary used app-wide (was hardcoded in
  // applyTheme.ts; values unchanged, just tenant-owned now).
  buttonPrimaryHex: '#002366',
  buttonPrimaryHoverHex: '#00337a',
  storagePrefix: 'twinpeakrealtors',
  copyrightHolder: 'Twin Peak Realtors'
}

export default twinpeakrealtorsConfig
